<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='500px'>
    <el-form :model='form' label-width='100px' label-position='right'
             :rules='rules' ref='ruleForm' class='settlement-form mt20'>
      <el-form-item label='完成日期：' prop='endTime'>
        <el-date-picker v-model='form.endTime' size='mini' class='w100' type='datetime'
                        placeholder='开始日期' />
      </el-form-item>
      <el-form-item label='交车区域：' prop='deliveryId'>
        <el-cascader
          size='mini'
          class='w100'
          ref='startPosition'
          v-model='form.deliveryId'
          placeholder='请选择交车区域'
          :options='positionOption'
          :props='props'
          filterable
          @change='handleChange' />
      </el-form-item>
      <el-form-item label='交车港口：' prop='deliveryPortId'>
        <el-select filterable v-model='form.deliveryPortId'
                   class='w100' size='mini' clearable
                   placeholder='请选择交车港口' value-key='id'>
          <el-option v-for='item in startPortList' :key='item.id'
                     :label='item.supplier_name'
                     :value='item.id'></el-option>
        </el-select>
      </el-form-item>
      <div style='display: flex;align-items: center;' class='mt10'>
        <batch-import ref="batchImportRef" :uploadUrl='uploadUrl' @importSuccess='importSuccess' :is-button='true' />
        <el-button class='mr10' type='primary' size='mini' @click='download'>模板下载</el-button>
        {{ `已导入：${form.carIds.length || 0}条数据` }}
      </div>

      <!--      <div class='content'>
              <div class='tableContainer'>
                <el-table
                  ref='registerTable'
                  v-loading='tableLoading'
                  row-key='id'
                  :data='tableData'
                  class='mt10'
                  style='width: 100%'
                  max-height='400px'
                  border
                  :header-cell-style='headerCellStyle'
                >
                  <el-table-column prop='batchNumber' label='批次号' align='center' width='160' />
                  <el-table-column prop='waybillNo' label='运单编号' align='center' width='140' />
                  <el-table-column prop='frameNumber' label='车架号' align='center' width='180' />
                  <el-table-column prop='brand' label='品牌' align='center' width='80px' />
                  <el-table-column prop='model' label='型号' align='center' width='80px' />
                  <el-table-column label='起运地' align='center' width='180'>
                    <template slot-scope='scope'>
                      {{ scope.row.startPortName ? scope.row.startPortName : scope.row.startName }}
                    </template>
                  </el-table-column>
                  <el-table-column label='交车地' align='center'>
                    <template slot-scope='scope'>
                      {{ scope.row.deliveryPortName ? scope.row.deliveryPortName : scope.row.deliveryName
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop='loadingDate' label='装车时间' align='center' width='100' />
                  <el-table-column prop='deliveryDate' label='交车时间' align='center' width='100' />
                  <el-table-column prop='state' label='交车时间' align='center' width='80px'
                                   :formatter='getStatus' />
                </el-table>
              </div>
              <div class='paginationContainer'>
                <span>共{{ total }}条</span>
                <el-pagination
                  background
                  :page-sizes='[10, 20, 30, 40]'
                  layout='sizes,prev, pager, next,jumper'
                  :total='total'
                  @size-change='contractSizeChange'
                  @current-change='contractCurrentChange'
                  @prev-click='contractCurrentChange'
                  @next-click='contractCurrentChange'
                />
              </div>
            </div>-->
      <div class='flex-center-center mt10 pb10'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { applicationAreaInfo } from '@/service/getData';
  import { addUnloadPrice, addUnloadPriceList, getSelectPort } from '@/service/vehiclelog';
  import BatchImport from './batchImport';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    name: 'sectionDelivery',
    components: { BatchImport },
    data() {
      return {
        dialogTitle: '分段交车',
        dialogVisible: false,
        defaultForm: {},
        form: {
          id: '',
          endTime: '',
          deliveryId: '',
          deliveryPortId: '',
          carIds: [],
        },
        rules: {
          endTime: [{
            required: true,
            message: '请选择完成日期',
            trigger: 'blur',
          }],
          deliveryId: [{
            required: true,
            message: '请选择交车区域',
            trigger: 'blur',
          }],
        },
        pagination: {
          size: 10,
          page: 1,
        },
        total: 0,
        submitLoading: false,
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        props: {
          value: 'id',
          label: 'cityName',
          children: 'children',
        },
        positionOption: [],
        startPortList: [],
        basicUrl: '/platform/deployFleet/frameNoQuery',
        uploadUrl: '',
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      // 每页数据条数改变
      contractSizeChange(sizes) {
        this.pagination.size = sizes;
        this.searchBtn();
      },
      // 当前页改变
      contractCurrentChange(page) {
        this.pagination.page = page;
        this.searchBtn();
      },
      async getAreaList() {
        const {
          status,
          message,
          data,
        } = await applicationAreaInfo();
        if (status !== 0) return this.$message.warning(message);
        this.positionOption = data;
      },
      dialogOpen(id) {
        const token = getSessionStore('token');
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.id = id;
        this.uploadUrl = `${this.basicUrl}?access_token=${token}&id=${id}`;
        this.$refs.batchImportRef.setUploadUrlNew(this.uploadUrl);
        this.searchBtn();
        this.dialogVisible = true;
        this.getAreaList();
      },
      importSuccess(carIds) {
        this.form.carIds = carIds;
      },
      async searchBtn() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await addUnloadPriceList({ deployPortId: this.form.id, ...this.pagination });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const submitParams = {
              ...this.form,
              deliveryId: this.form.deliveryId.join('/'),
            };
            const res = await addUnloadPrice(submitParams);
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
      // 交车区域改变
      async handleChange(value) {
        this.form.deliveryPortId = '';
        await this.getSelectPort(value[value.length - 1], 1);
      },
      // 根据区域获取港口
      async getSelectPort(id) {
        let port = await getSelectPort(id);
        if (port.status !== 0) return this.$message.error(port.message);
        this.startPortList = port.data;
        this.$forceUpdate();
      },
      getStatus(row) {
        switch (row.state) {
          case 0:
            return '待装车';
          case 1:
            return '已装车';
          case 2:
            return '已交车';
          case -1:
            return '已取消';
        }
      },
      //模板下载
      download() {
        window.location.href = '/file/导入委托车模板.xls';
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 90%;
    margin: 0 auto;
  }

  .el-input {
    width: 165px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }
</style>
